import axios from "axios";
import endpoints from "@/api/endpoints";

export class MessService {
  static __instance = null;

  constructor() {
    if (MessService.__instance) {
      return MessService.__instance;
    }

    MessService.__instance = this;
  }

  getMess(page) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${endpoints.mess}?page=${page}`)
        .then(response => {
          if (response.data) {
            return resolve(response.data);
          } else return reject("Server error");
        })
        .catch(err => reject(err));
    });
  }
}

export const messService = new MessService();
